export default "__VITE_ASSET__CHwXeH6W__"